export const ENDPOINTS = {
  ALL_TRANSACTIONS: "/v1/admin/transaction/all",
  TRANSACTION_ANALYTICS: "/v1/admin/transaction/analytics",
  TRANSACTION_METRICS: "/v1/admin/transaction/metrics",
  SINGLE_TRANSACTION: (id) => `/v1/admin/transaction/${id}`,
  UPDATE_REPAYMENT: (id, repaymentId) => `/v1/admin/finance/update-repayment/${id}/${repaymentId}`,
};